import {useRef} from 'react';
import {v4 as uuidv4} from 'uuid';

export default function useTabId(): string {
  const tabIdRef = useRef<string | null>(null);

  if (tabIdRef.current === null) {
    let tabId = sessionStorage.getItem('tabId');
    if (!tabId) {
      tabId = uuidv4();
      sessionStorage.setItem('tabId', tabId);
    }
    tabIdRef.current = tabId;
  }

  return tabIdRef.current;
}
